import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

/* ── Brand tokens · dark studio theme · magenta→violet neon ──────────
   Dark, sober surfaces (devs live in IDEs and server panels) with the
   pink/violet neon kept as accent. Pages read from these tokens — never
   hardcode #fff. */
export const P    = '#A366FF';                 // violet, brightened for dark bg
export const PK   = '#F20CC9';                 // magenta neon
export const BG   = '#0A0A11';                 // page background
export const BG2  = '#0F0F19';                 // alt / elevated section band
export const CARD = '#13131F';                 // card surface
export const SOFT = '#181824';                 // soft inset surface
export const INK  = '#F3F2F8';                 // primary text
export const SUB  = '#9C9CAD';                 // secondary text
export const LINE = '#25252F';                 // hairline border
export const GRAD = `linear-gradient(120deg,${PK},${P})`;
export const GLOW = 'rgba(163,102,255,.32)';
export const H1   = { fontFamily:"'Manrope',sans-serif", fontWeight:700, letterSpacing:'-.01em' };
export const CONTACT_EMAIL = 'support@cywerstudio.com';

/* External storefronts. */
export const STORES = {
  assetstore: { label:'Unity Asset Store', href:'https://assetstore.unity.com/publishers/134800' },
  spigotmc:   { label:'SpigotMC',          href:'#' },
  builtbybit: { label:'BuiltByBit',        href:'https://builtbybit.com/members/cywerst.923685/' },
};

export const SITE_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  html{scroll-behavior:smooth;background:${BG}}
  body{font-family:'Manrope',sans-serif;background:${BG};color:${INK}}
  ::selection{background:rgba(163,102,255,.28);color:#fff}

  @keyframes glowPulse{0%,100%{opacity:.5;transform:scale(1)}50%{opacity:.85;transform:scale(1.06)}}
  @keyframes blink{0%,100%{opacity:1}50%{opacity:.35}}
  @keyframes riseIn{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
  @keyframes floaty{0%,100%{transform:translateY(0)}50%{transform:translateY(-14px)}}
  .floaty{animation:floaty 6.5s ease-in-out infinite}
  @media(prefers-reduced-motion:reduce){.floaty{animation:none}}
  .glowA{animation:glowPulse 7s ease-in-out infinite}
  .glowB{animation:glowPulse 9s ease-in-out infinite 1.5s}
  .dotB{animation:blink 2.4s ease-in-out infinite}
  .hero-r{opacity:0;animation:riseIn .7s cubic-bezier(.22,1,.36,1) forwards}
  .reveal{opacity:0;transform:translateY(20px);transition:opacity .65s ease,transform .65s cubic-bezier(.22,1,.36,1)}
  .reveal.in{opacity:1;transform:none}
  @media(prefers-reduced-motion:reduce){
    .glowA,.glowB,.dotB,.hero-r{animation:none!important;opacity:1!important}
    .reveal{opacity:1!important;transform:none!important;transition:none!important}
  }

  .cs-nav a.nl{font-size:14px;color:${SUB};text-decoration:none;transition:color .15s;font-weight:500}
  .cs-nav a.nl:hover{color:${INK}}
  .cs-nav a.nl.on{color:${INK};font-weight:600}
  .cs-nav .nav-links{display:flex;gap:26px;align-items:center}
  .cs-nav .desk-cta{display:flex;align-items:center;gap:8px}
  .burger{display:none;width:42px;height:42px;border:1px solid ${LINE};border-radius:11px;background:${CARD};cursor:pointer;align-items:center;justify-content:center;flex-direction:column;gap:5px}
  .burger span{display:block;width:18px;height:2px;background:${INK};border-radius:2px;transition:transform .22s,opacity .22s}
  .burger.x span:nth-child(1){transform:translateY(7px) rotate(45deg)}
  .burger.x span:nth-child(2){opacity:0}
  .burger.x span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}
  .mmenu{position:fixed;top:64px;left:0;right:0;z-index:99;background:${BG2};border-bottom:1px solid ${LINE};box-shadow:0 20px 44px rgba(0,0,0,.5);padding:12px 20px 20px;display:flex;flex-direction:column;gap:2px;animation:riseIn .22s cubic-bezier(.22,1,.36,1) both}
  .mmenu a,.mmenu button{font-size:16px;font-weight:600;color:${INK};text-decoration:none;text-align:left;padding:13px 10px;border-radius:10px;border:none;background:none;cursor:pointer}
  .mmenu a:hover,.mmenu button:hover{background:${SOFT}}

  .btn-p{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:48px;padding:0 28px;border:none;border-radius:12px;cursor:pointer;background:${GRAD};font-weight:600;font-size:15px;color:#fff;text-decoration:none;box-shadow:0 8px 24px ${GLOW};transition:transform .18s cubic-bezier(.22,1,.36,1),box-shadow .18s}
  .btn-p:hover{transform:translateY(-2px);box-shadow:0 14px 34px rgba(163,102,255,.5)}
  .btn-ps{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:40px;padding:0 18px;border:none;border-radius:10px;cursor:pointer;background:${GRAD};font-weight:600;font-size:13px;color:#fff;text-decoration:none;box-shadow:0 6px 18px ${GLOW};transition:transform .18s,box-shadow .18s}
  .btn-ps:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(163,102,255,.5)}
  .btn-g{display:inline-flex;align-items:center;justify-content:center;height:48px;padding:0 26px;border-radius:12px;border:1px solid ${LINE};cursor:pointer;background:transparent;font-weight:500;font-size:15px;color:${INK};text-decoration:none;transition:border-color .18s,color .18s,transform .18s}
  .btn-g:hover{border-color:${P};color:${P};transform:translateY(-2px)}
  .btn-gs{display:inline-flex;align-items:center;justify-content:center;height:40px;padding:0 16px;border-radius:10px;border:1px solid ${LINE};cursor:pointer;background:transparent;font-weight:500;font-size:13px;color:${INK};text-decoration:none;transition:border-color .18s,color .18s}
  .btn-gs:hover{border-color:${P};color:${P}}
  .btn-d{display:inline-flex;align-items:center;justify-content:center;height:48px;padding:0 26px;border-radius:12px;border:1px solid ${LINE};background:${SOFT};font-weight:600;font-size:15px;color:${SUB};cursor:not-allowed;text-decoration:none}

  .tag{display:inline-flex;align-items:center;gap:8px;padding:6px 14px;border:1px solid rgba(163,102,255,.32);border-radius:999px;background:rgba(163,102,255,.09);font-size:11px;font-weight:600;color:${P};letter-spacing:.12em;text-transform:uppercase}

  .svc,.work{transition:transform .22s cubic-bezier(.22,1,.36,1),box-shadow .22s,border-color .22s}
  .svc:hover,.work:hover{transform:translateY(-5px);box-shadow:0 20px 44px rgba(0,0,0,.45);border-color:rgba(163,102,255,.45)}

  .inp{width:100%;height:50px;background:${SOFT};border:1px solid ${LINE};border-radius:12px;padding:0 15px;font-family:'Manrope',sans-serif;font-size:15px;font-weight:500;color:${INK};outline:none;transition:border-color .18s,box-shadow .18s}
  .inp:focus{border-color:${P};box-shadow:0 0 0 3px rgba(163,102,255,.18)}
  .txt{width:100%;min-height:150px;background:${SOFT};border:1px solid ${LINE};border-radius:12px;padding:13px 15px;font-family:'Manrope',sans-serif;font-size:15px;font-weight:500;color:${INK};outline:none;resize:vertical;transition:border-color .18s,box-shadow .18s}
  .txt:focus{border-color:${P};box-shadow:0 0 0 3px rgba(163,102,255,.18)}
  select.inp{appearance:none;-webkit-appearance:none;cursor:pointer}
  ::placeholder{color:#5f5f6d}

  .fl{font-size:13px;color:${SUB};text-decoration:none;transition:color .15s}
  .fl:hover{color:${P}}

  /* Homepage: hero visual, marquee, icon tiles */
  .hero2{display:grid;grid-template-columns:1.04fr .96fr;gap:clamp(24px,5vw,60px);align-items:center}
  .hero-visual{position:relative;height:clamp(360px,42vw,500px)}
  .hcard{position:absolute;border-radius:18px;overflow:hidden;border:1px solid ${LINE};box-shadow:0 30px 70px rgba(0,0,0,.55);background:${CARD}}
  .hcard img{width:100%;height:100%;object-fit:cover;display:block}
  .hcard .cap{position:absolute;left:0;right:0;bottom:0;padding:12px 14px;background:linear-gradient(to top,rgba(6,6,12,.92),rgba(6,6,12,0));display:flex;align-items:center;justify-content:space-between;gap:8px}
  @keyframes floaty2{0%,100%{transform:translateY(0) rotate(var(--r,0deg))}50%{transform:translateY(-16px) rotate(var(--r,0deg))}}
  .fl2{animation:floaty2 7s ease-in-out infinite}
  @media(prefers-reduced-motion:reduce){.fl2{animation:none}}
  .iconTile{width:52px;height:52px;border-radius:14px;display:flex;align-items:center;justify-content:center;border:1px solid ${LINE};background:rgba(163,102,255,.08)}
  .iconTile svg{width:26px;height:26px}
  @keyframes marquee{from{transform:translateX(0)}to{transform:translateX(-50%)}}
  .mq{overflow:hidden;position:relative;-webkit-mask-image:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent);mask-image:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)}
  .mq-row{display:flex;gap:12px;width:max-content;animation:marquee 32s linear infinite}
  @media(prefers-reduced-motion:reduce){.mq-row{animation:none;flex-wrap:wrap;justify-content:center}}
  .mq-item{display:inline-flex;align-items:center;gap:9px;padding:10px 18px;border:1px solid ${LINE};border-radius:999px;background:${CARD};color:${SUB};font-size:14px;font-weight:600;white-space:nowrap}
  .mq-item i{width:6px;height:6px;border-radius:50%;background:${GRAD};display:inline-block}
  @media(max-width:900px){.hero2{grid-template-columns:1fr}.hero-visual{display:none}}

  @media(max-width:820px){
    .cs-nav .nav-links{display:none}
    .cs-nav .desk-cta{display:none}
    .burger{display:flex}
    .two-col{grid-template-columns:1fr !important}
    .foot-grid{grid-template-columns:1fr 1fr !important}
  }
  @media(min-width:821px){ .burger{display:none} .mmenu{display:none} }
`;

export const G = ({ children }) => (
  <span style={{ background:GRAD,WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text' }}>{children}</span>
);

/* Brand logo (favicon mark). The mark is already light on transparent. */
export const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/android-chrome-512x512.png`;
export function Logo({ height = 32, style }) {
  return (
    <img src={LOGO_SRC} alt="CywerStudio" width={height} height={height}
      style={{ height, width:height, display:'block', objectFit:'contain', ...style }} />
  );
}

const NAV = [
  ['produtos','Products','/produtos'],
  ['servicos','Services','/servicos'],
  ['estudio','Studio','/estudio'],
  ['apparel','Apparel','/apparel'],
  ['contacto','Contact','/contacto'],
];

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeM = () => setMenuOpen(false);
  return (
    <nav className="cs-nav" style={{ position:'fixed',top:0,left:0,right:0,zIndex:100,height:64,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 clamp(20px,5vw,48px)',borderBottom:`1px solid ${LINE}`,background:'rgba(10,10,17,.78)',backdropFilter:'blur(16px)' }}>
      <div style={{ display:'flex',alignItems:'center',gap:30 }}>
        <Link to="/" style={{ display:'inline-flex',alignItems:'center',gap:10,textDecoration:'none' }} aria-label="CywerStudio">
          <Logo height={32} />
          <span style={{ ...H1,fontSize:17,color:INK,letterSpacing:'-.02em' }}>CywerStudio</span>
        </Link>
        <div className="nav-links">
          {NAV.map(([k,l,to]) => (
            <Link key={k} to={to} className={`nl${window.__cs_active===k?' on':''}`} style={{ display:'inline-flex',alignItems:'center',gap:6 }}>
              {l}{k==='apparel' && <span style={{ fontSize:9,fontWeight:800,letterSpacing:'.06em',color:'#fff',background:GRAD,padding:'2px 6px',borderRadius:999,lineHeight:1 }}>NEW</span>}
            </Link>
          ))}
        </div>
      </div>
      <div style={{ display:'flex',alignItems:'center',gap:8 }}>
        <div className="desk-cta">
          <Link to="/produtos" className="btn-ps">View products</Link>
        </div>
        <button className={`burger${menuOpen ? ' x' : ''}`} aria-label="Menu" onClick={() => setMenuOpen(o => !o)}>
          <span /><span /><span />
        </button>
      </div>
      {menuOpen && (
        <div className="mmenu">
          {NAV.map(([k,l,to]) => <Link key={k} to={to} onClick={closeM}>{l}</Link>)}
          <div style={{ height:1,background:LINE,margin:'8px 4px' }} />
          <Link to="/produtos" onClick={closeM} style={{ color:P }}>View products →</Link>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  return (
    <footer style={{ borderTop:`1px solid ${LINE}`,background:BG2,padding:'52px clamp(20px,5vw,48px) 34px' }}>
      <div style={{ maxWidth:1160,margin:'0 auto' }}>
        <div className="foot-grid" style={{ display:'grid',gridTemplateColumns:'2fr 1fr 1fr 1fr',gap:40,marginBottom:42 }}>
          <div>
            <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:16 }}>
              <Logo height={34} />
              <span style={{ ...H1,fontSize:18,color:INK }}>CywerStudio</span>
            </div>
            <p style={{ fontSize:14,color:SUB,fontWeight:500,lineHeight:1.7,maxWidth:300 }}>Multiplayer and server tools you configure without code. For Unity developers and Minecraft server owners.</p>
          </div>
          <div>
            <p style={{ fontWeight:700,fontSize:13,color:INK,marginBottom:14 }}>Site</p>
            <div style={{ display:'flex',flexDirection:'column',gap:11 }}>
              <Link to="/produtos" className="fl">Products</Link>
              <Link to="/servicos" className="fl">Services</Link>
              <Link to="/estudio" className="fl">Studio</Link>
              <Link to="/apparel" className="fl">Apparel</Link>
              <Link to="/changelog" className="fl">Changelog</Link>
              <Link to="/blog" className="fl">Blog</Link>
              <Link to="/contacto" className="fl">Contact</Link>
            </div>
          </div>
          <div>
            <p style={{ fontWeight:700,fontSize:13,color:INK,marginBottom:14 }}>Stores</p>
            <div style={{ display:'flex',flexDirection:'column',gap:11 }}>
              <a href={STORES.assetstore.href} target="_blank" rel="noreferrer" className="fl">Unity Asset Store</a>
              <a href={STORES.spigotmc.href} target="_blank" rel="noreferrer" className="fl">SpigotMC</a>
              <a href={STORES.builtbybit.href} target="_blank" rel="noreferrer" className="fl">BuiltByBit</a>
            </div>
          </div>
          <div>
            <p style={{ fontWeight:700,fontSize:13,color:INK,marginBottom:14 }}>Legal</p>
            <div style={{ display:'flex',flexDirection:'column',gap:11 }}>
              {[['/privacy','Privacy'],['/terms','Terms'],['/cookies','Cookies'],['/refund','Refunds']].map(([p,l]) => (
                <Link key={l} to={p} className="fl">{l}</Link>
              ))}
            </div>
          </div>
        </div>
        <div style={{ borderTop:`1px solid ${LINE}`,paddingTop:24,display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:12 }}>
          <p style={{ fontSize:13,color:'#6a6a78',fontWeight:500 }}>© 2026 CywerStudio. Independent studio · Portugal.</p>
          <div style={{ display:'flex',gap:18 }}>
            <Link to="/changelog" className="fl">Changelog</Link>
            <Link to="/contacto" className="fl">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* Shared page shell: <style> + fixed nav + reveal observer + footer.
   `active` highlights the current nav item. */
const BASE_TITLE = 'CywerStudio — multiplayer and server tools, without code';
const BASE_DESC  = 'Tools for Unity developers and Minecraft server owners. Server-authoritative multiplayer and plugins you configure through a GUI — never through files or code.';

export function SiteShell({ children, active, title, desc }) {
  useEffect(() => { window.__cs_active = active; }, [active]);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => {
    document.title = title ? `${title} · CywerStudio` : BASE_TITLE;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement('meta'); m.name = 'description'; document.head.appendChild(m); }
    m.setAttribute('content', desc || BASE_DESC);
  }, [title, desc]);
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(el=>el.classList.add('in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold:0.1, rootMargin:'0px 0px -6% 0px' });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, [children]);
  return (
    <>
      <style>{SITE_CSS}</style>
      <div style={{ minHeight:'100vh', background:BG, fontFamily:"'Manrope',sans-serif", color:INK, overflowX:'hidden' }}>
        <Nav />
        {children}
        <Footer />
      </div>
    </>
  );
}

/* Simple page header used by sub-pages (clears the fixed nav). */
export function PageHead({ tag, title, accent, lead }) {
  return (
    <header style={{ position:'relative',overflow:'hidden',padding:'clamp(120px,16vw,180px) clamp(20px,5vw,48px) clamp(40px,6vw,64px)' }}>
      <div className="glowA" style={{ position:'absolute',top:'-30%',left:'50%',transform:'translateX(-50%)',width:820,height:820,background:'radial-gradient(circle,rgba(163,102,255,.16) 0%,transparent 62%)',pointerEvents:'none' }} />
      <div style={{ position:'relative',zIndex:1,maxWidth:1120,margin:'0 auto' }}>
        <div className="hero-r" style={{ marginBottom:20,animationDelay:'.05s' }}>
          <span className="tag"><span className="dotB" style={{ width:5,height:5,borderRadius:'50%',background:P,boxShadow:`0 0 8px ${P}` }} />{tag}</span>
        </div>
        <h1 className="hero-r" style={{ ...H1,fontSize:'clamp(36px,6vw,64px)',lineHeight:1.05,color:INK,animationDelay:'.14s',maxWidth:820 }}>
          {title} {accent && <G>{accent}</G>}
        </h1>
        {lead && <p className="hero-r" style={{ fontSize:'clamp(16px,1.8vw,19px)',color:SUB,lineHeight:1.65,fontWeight:500,maxWidth:660,marginTop:20,animationDelay:'.26s' }}>{lead}</p>}
      </div>
    </header>
  );
}
